import React, { FC } from 'react'
import styles from './FilterTitle.module.scss'
interface Props {
  title: string
}

export const FilterTitle: FC<Props> = ({ title }) => {
  return <div className={styles.Container}>{title}</div>
}
